import { Component, Injector, Input, ViewChild, inject } from '@angular/core';
import {
    ControlContainer,
    ControlValueAccessor,
    FormControl,
    FormControlDirective,
} from '@angular/forms';

@Component({
    template: '',
})
export abstract class AbstractFormControlValueAccessorComponent
    implements ControlValueAccessor
{
    /**
     * @link https://angular.io/api/forms/ControlValueAccessor#methods
     */

    @ViewChild(FormControlDirective, { static: true })
    formControlDirective: FormControlDirective | undefined;

    @Input()
    formControl!: FormControl;

    @Input()
    formControlName: string | undefined;

    private readonly injector = inject(Injector);

    /**
     *  Use this getter in FormControl on mat-select to make connection with provided formControl of Parent
     *
     *  this.formControl => When a formControl Obj is Provided from parent
     *  this.formControl => When name of a formControl in Parent Form is Provided
     *
     */
    get control(): any {
        if (this.formControlName && this.controlContainer.control) {
            return this.controlContainer.control.get(this.formControlName);
        }

        return this.formControl;
    }

    get controlContainer(): ControlContainer {
        return this.injector.get(ControlContainer);
    }

    registerOnTouched(fn: any): void {
        if (this.formControlDirective?.valueAccessor) {
            this.formControlDirective.valueAccessor.registerOnTouched(fn);
        }
    }

    registerOnChange(fn: any): void {
        if (this.formControlDirective?.valueAccessor) {
            this.formControlDirective.valueAccessor.registerOnChange(fn);
        }
    }

    writeValue(obj: any): void {
        if (this.formControlDirective?.valueAccessor) {
            this.formControlDirective.valueAccessor.writeValue(obj);
        }
    }

    setDisabledState(isDisabled: boolean): void {
        if (this.formControlDirective?.valueAccessor?.setDisabledState) {
            this.formControlDirective.valueAccessor.setDisabledState(
                isDisabled
            );
        }
    }
}
